import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PublicOnly, RequireAuth, RequireEnrolable, RequireSessionState } from "@/components/guards/RouteGuards";
import SignIn from "@/pages/SignIn";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import MfaChallenge from "@/pages/MfaChallenge";
import MfaSetup from "@/pages/MfaSetup";
import AccountHome from "@/pages/account/AccountHome";
import AccountSecurity from "@/pages/account/AccountSecurity";
import HubHome from "@/pages/hub/HubHome";
import HubSecurity from "@/pages/hub/HubSecurity";
import HubPeople from "@/pages/hub/HubPeople";
import HubAudit from "@/pages/hub/HubAudit";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/sign-in" replace />} />
          <Route path="/sign-in" element={<PublicOnly><SignIn /></PublicOnly>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/mfa" element={<RequireSessionState state="mfa_required"><MfaChallenge /></RequireSessionState>} />
          <Route path="/mfa/setup" element={<RequireEnrolable><MfaSetup /></RequireEnrolable>} />
          <Route path="/account" element={<RequireAuth area="/account"><AccountHome /></RequireAuth>} />
          <Route path="/account/security" element={<RequireAuth area="/account"><AccountSecurity /></RequireAuth>} />
          <Route path="/hub" element={<RequireAuth area="/hub"><HubHome /></RequireAuth>} />
          <Route path="/hub/security" element={<RequireAuth area="/hub"><HubSecurity /></RequireAuth>} />
          <Route path="/hub/people" element={<RequireAuth area="/hub" capability="management.users.read"><HubPeople /></RequireAuth>} />
          <Route path="/hub/audit" element={<RequireAuth area="/hub" capability="audit.read"><HubAudit /></RequireAuth>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: { background: "#121518", border: "1px solid rgba(255,255,255,0.1)", color: "#fff", fontFamily: '"IBM Plex Sans", sans-serif' },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
